<template>
<card class="card-user">
    <div slot="image">
        <img src="@/assets/img/profili_cover.png" />
    </div>
    <v-divider
  :thickness="2"
  class="border-opacity-25"
  color="error"
></v-divider>
    <div>
        <div class="author">
            <img class="avatar border-white" v-bind:src="id_photo" @error="$event.target.src='http://pic.e-cmd.org/cmdpic/avatar.jpg'" />
            <h4 class="title">
                <div class="text-center" v-if="loader">
                    <div class="spinner-border" role="status">
                        <span class="visually-hidden"></span>
                    </div>
                </div>
                {{ profili.emri }}
                {{ profili.mbiemri }}
                <br />
                <a href="#">
                    <small>{{ profili.indeksi }}</small>
                </a>
            </h4>
        </div>
        <p class="description text-center">
            {{ profili.programi }}
        </p>
    </div>
    <!-- Bbutoni -->
    <v-btn class="text-center">
        <a color="primary" @click="compose({})"><i class="ti-user"> </i>&nbsp;Ndrysho Fjalekalimin</a>
    </v-btn>
    <hr />
    <div class="text-center">
        <div class="row">
            <div v-for="(info, index) in details" :key="index" :class="getClasses(index)">
                <h5> {{ info.title }} <br /> <small> {{ info.subTitle }} </small> </h5>
            </div>
        </div>
    </div>
    <!-- Modal -->
    <v-app>
        <v-dialog v-model="dialogCompose" width="500">
            <v-card>
                <v-card-title class="headline black" primary-title>
                    Ndrysho Fjalëkalimin
                </v-card-title>
                <v-card-text class="pa-5">

                    <v-text-field label="Fjalëkalimi i ri" id="password1" v-model="passwordi1"></v-text-field>
                    <v-text-field label="Përsëritni fjalëkalimin e ri" id="password2" v-model="passwordi2"></v-text-field>

                </v-card-text>
                <v-card-actions class="pa-5">
                    <v-btn class="ml-auto" @click=" setPassword()" outlined color="primary">Ruaj</v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-app>
    <div class="alert alert-danger" v-if="gabim">
        <strong>Fjalëkalimet</strong> nuk përputhen mes vete provoni perseri !!
    </div>
    <div class="alert alert-success" v-if="sukses">
        <strong>Fjalëkalimi</strong> u ruajt me sukses.
    </div>
    <div class="alert alert-danger" v-if="zbrazet">
        Kujdes keni hapësir të zbrazët !!
    </div>
    <div class="alert alert-danger" v-if="kujdes">
        Kujdes, fjalëkalimi nuk duhet të jetë më i shkurtër se 6 karaktere !
    </div>
    <!-- /Modal -->
</card>
</template>

<script>
import { APISettings } from '../../api/config.js'
import Vuetify from 'vuetify'

export default {
    data() {
        return {
            details: [{
                    title: "",
                    subTitle: "Niveli",
                },
                {
                    title: "",
                    subTitle: "Mënyra e studimit",
                },
                {
                    title: "",
                    subTitle: "Qendra",
                },

            ],
            profili: {},
            id_photo: "",
            loader: false,

            // Modal Compose
            dialogCompose: false,
            passwordi1: "",
            passwordi2: "",
            sukses: false,
            gabim: false,
            zbrazet: false,
            kujdes: false,
        };

    },

    vuetify: new Vuetify({
        theme: {
            themes: {
                dark: {
                    primary: '#dc3545'
                }
            },
            dark: true
        }
    }),

    methods: {

        getClasses(index) {
            var remainder = index % 3;
            if (remainder === 0) {
                return "col-lg-3 offset-lg-1";
            } else if (remainder === 2) {
                return "col-lg-4";
            } else {
                return "col-lg-3";
            }
        },
        compose() {
            this.dialogCompose = true
        },
        saveDraft() {

            this.dialogCompose = false
            console.log(this.passwordi1);
            console.log(this.passwordi2);
        },

        getData() {

            this.loader = true;
            var get_token = this.$cookies.get("accesstoken");
            fetch(APISettings.baseURL + `Profili/getProfiliNew/`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + get_token
                    },
                })
                .then(
                    (signinResponse) => {

                        signinResponse.json().then((res) => {
                            if (signinResponse.status === 200) {
                                res.forEach(obj => {
                                    this.profili = obj;

                                    this.id_photo = `http://pic.e-cmd.org/cmdpic/1005/${this.profili.studentiGUID}_thumbnail.jpg`;
                                    this.details[0].title = this.profili.niveli;
                                    this.details[1].title = this.profili.menyra_e_studimit;
                                    this.details[2].title = this.profili.qendra;
                                });
                            } else if (signinResponse.status === 400) {
                                console.log("ERROR DATA1");
                            }
                            this.loader = false;
                        })
                    }).catch(error => {
                    console.log("ERROR DATA2");
                })
        },
        setPassword() {
            if (this.passwordi1.length == "" || this.passwordi2 == "") {
                this.zbrazet = true;
                setTimeout(() => this.zbrazet = false, 5000);
                this.dialogCompose = false;
            } else {
                if (this.passwordi1.length < 5 || this.passwordi2.length < 5) {
                    this.kujdes = true;
                    setTimeout(() => this.kujdes = false, 5000);
                    this.dialogCompose = false;
                } else {
                    if (this.passwordi1 === this.passwordi2) {
                        this.loader2 = true;
                        var get_token = this.$cookies.get("accesstoken");
                        fetch(APISettings.baseURL + `Profili`, {
                                method: 'PUT',
                                headers: {
                                    'Content-Type': 'application/json',
                                    Authorization: 'Bearer ' + get_token
                                },
                                body: JSON.stringify({
                                    paswordi: this.passwordi1,
                                })
                            })
                            .then(
                                (signinResponse) => {
                                    this.logini = true;
                                    signinResponse.json().then((res) => {
                                        if (signinResponse.status === 200) {
                                            this.sukses = true;
                                            setTimeout(() => this.sukses = false, 5000);
                                            this.dialogCompose = false;

                                        } else if (signinResponse.status === 400) {

                                        }
                                    })
                                }).catch(error => {
                                this.gabim = true;
                                setTimeout(() => this.gabim = false, 5000);
                            })

                    } else {
                        this.gabim = true;
                        setTimeout(() => this.gabim = false, 5000);
                        this.dialogCompose = false;
                    }
                }

            }

        },
    },

    beforeMount() {
        this.getData();
    },

};
</script>

<style scoped>
::v-deep .v-application--wrap {
    min-height: fit-content;

}

.v-btn:not(.v-btn--round).v-size--default {
    position: relative;
    margin-left: 50%;
    transform: translateX(-50%);
    font-size: 14px;
    text-transform: capitalize;
}

.card-user {
    box-shadow: 0 2px 2px rgb(220 59 69 / 50%);
}
</style>
